export type CreateUserRolesRequest = {
  userRoles: {
    idx: number;
    userId: string;
    roleCd: string;
    cvrgCd: string;
    primFlg: string;
  }[];
};
